import axios from 'axios';

import { getLocaleFromPath } from '@/shared/api/client/base';

const getOS = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  if (userAgent.includes('iphone')) {
    return 'IOS';
  } else if (userAgent.includes('android')) {
    return 'AND';
  }
  return 'ETC';
};

const getLocalePathName = () => {
  const locale = getLocaleFromPath();
  switch (locale) {
    case 'ko-KR':
      return 'KorService1';
    case 'en-US':
      return 'EngService1';
    case 'zh-CN':
      return 'ChsService1';
    // case 'zh-TW':
    //   return 'ChtService1';
  }
};

export const travelBaseURL = `/api/tours`;

export const travelClient = axios.create({
  baseURL: travelBaseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

travelClient.interceptors.request.use(
  (config) => {
    const MobileOS = getOS();
    const locale = getLocalePathName();
    config.params = {
      ...config.params,
      localePathname: locale,
      MobileOS,
    };

    return config;
  },
  (error) => Promise.reject(error),
);
